import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import Trip from "./pages/Trip";
import Deals from "./pages/Deals";
import ContactUs from "./pages/ContactUs";
import MyBooking from "./pages/MyBooking";
import AboutUs from "./pages/AboutUs";
import GetInTouch from "./pages/GetInTouch";
import HelpCenter from "./pages/HelpCenter";
import Hotel from "./pages/Hotel";
import Flights from "./pages/Flights";
import FlightDetails from "./pages/FlightDetails";
import HotelDetails from "./pages/HotelDetails";
import Hotel2 from "./pages/Hotel2";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Footer from "./components/Footer";
import { useTranslation } from "react-i18next";


function Layout() {
  const location = useLocation();
  const hideHeaderFooter = ["/sign-in", "/sign-up"].includes(location.pathname);
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.body.dir = lng === "ar" ? "rtl" : "ltr"; // flip layout
  };


  return (
    <>
    {/* <div className="language-switcher">
        <button onClick={() => changeLanguage("en")}>English</button>
        <button onClick={() => changeLanguage("ar")}>عربي</button>
      </div> */}
      {!hideHeaderFooter && <Header changeLanguage={changeLanguage} />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/trip" element={<Trip />} />
        <Route path="/deals" element={<Deals />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/mybooking" element={<MyBooking />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/get-in-touch" element={<GetInTouch />} />
        <Route path="/help-center" element={<HelpCenter />} />
        <Route path="/hotel" element={<Hotel />} />
        <Route path="/flights" element={<Flights />} />
        <Route path="/flight-details" element={<FlightDetails />} />
        <Route path="/hotel-details" element={<HotelDetails />} />
        <Route path="/hotel2" element={<Hotel2 />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
      </Routes>

      {!hideHeaderFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;
